import styled from 'styled-components'

import { HeadingXL, SmallText, TextLink } from '../../component-library/design/typography/typography.styles'
import { COLOR } from '../../component-library/design/color/color.constants'
import { SPACING } from '../../component-library/design/spacing/spacing.constants'
import { Button } from '../../component-library/components/button/button.component'
import { FONT_SIZE } from '../../component-library/design/typography/typography.constants'
import { BREAKPOINT } from '../../design/breakpoint.constant'

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  height: ${props => (props.numberOfVehicles > 4 ? '1070px' : '870px')};
  background-color: ${COLOR.GREY_LIGHTEST};
  padding: ${SPACING.M} ${SPACING.S} ${SPACING.XS};
  
  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    height: ${props => (props.numberOfVehicles > 3 ? '1040px' : '500px')};
  }

  @media screen and (min-width: ${BREAKPOINT.DESKTOP}) {
    height: ${props => (props.numberOfVehicles > 3 ? '970px' : '500px')};
  }
`

const Title = styled(HeadingXL)`
  margin-bottom: ${SPACING.S};
  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    margin-bottom: ${SPACING.XL};
  }

`
const VehiclesContainer = styled.div`
  max-width: 430px;
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: center;
  align-items: flex-start;
  @media screen and (min-width: ${BREAKPOINT.TABLET}) {
    max-width: ${props => (props.numberOfVehicles % 8 === 0 ? '1165px' : props.numberOfVehicles === 4 ? '600px' : '800px')};
    padding-left: ${props => (props.numberOfVehicles % 4 === 0 ? `${SPACING.XL}` : '0px')}  
  }
`

const PlaceOrderButton = styled(Button)`
  align-self: center;
  margin-bottom: ${SPACING.S};
  margin-top: ${SPACING.XL};
`

const ChooseVehicleLink = styled(TextLink)`
  align-self: center;
  font-size: ${FONT_SIZE.SMALL};
`

const StyledSmallText = styled(SmallText)`
margin-top: ${SPACING.XL};
`


export { Title, Container, VehiclesContainer, PlaceOrderButton, ChooseVehicleLink, StyledSmallText }
